import React, { useEffect, useState } from "react";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { GetRegNo, studentUpdate } from "../../api/StudentServices";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { LoadingDiv, SweetAlertShow } from "../master/Master";
import { DistrictFetch, StateFetch } from "../../api/LocationService";
import StudentHeader from "../students/v2/StudentHeader";
import { studentDetails } from "../../api/Student";
import Master from "./Master";
import useAppConfig from "../config/useAppConfig";
import { imgBaseUrl } from "../../api/api";

export default function StudentUpdate() {
  const config = useAppConfig("Student", "admission_fields");
  const [loading, setLoading] = useState("");
  const [studentView, setStudentView] = useState();
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [originalFile, setOriginalFile] = useState(null);
  const [searchReg, setSearchReg] = useState("");
  const [alredy, setAlredy] = useState(null);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const studentId = queryParams.get("id");
  const navigate = useNavigate();
  const [error, setError] = useState("");

  const fieldConfig = (() => {
    try {
      return JSON.parse(config?.value || "[]");
    } catch {
      return [];
    }
  })();

  const getField = (name) => {
    return (
      fieldConfig.find((f) => f.field === name) || {
        show: 1,
        required: 0,
      }
    );
  };

  const getRegestrationNo = async () => {
    const addURl = `&student_id=${studentId}&registration_no=${searchReg}`;
    setLoading(true);

    try {
      const response = await GetRegNo(addURl);
      if (response.data.status) {
        if (response.data.message) {
          setAlredy(response.data);
        } else {
          setAlredy(null);
        }
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (searchReg) {
      getRegestrationNo();
    }
  }, [searchReg]);

  const handleImageChange_2 = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setOriginalFile(file);

    const maxSizeMB = 2;
    const targetSize = 0.9 * 1024 * 1024;
    const maxDimension = 800;

    try {
      console.log("Original size:", (file.size / 1024 / 1024).toFixed(2), "MB");
      const compressedFile = await compressImage(file, targetSize);
      const img = new Image();
      img.src = URL.createObjectURL(compressedFile);
      await new Promise((resolve) => (img.onload = resolve));

      let width = img.width;
      let height = img.height;

      if (width > maxDimension || height > maxDimension) {
        const scale = Math.min(maxDimension / width, maxDimension / height);
        const canvas = document.createElement("canvas");
        canvas.width = width * scale;
        canvas.height = height * scale;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        const blob = await new Promise((res) =>
          canvas.toBlob(res, "image/jpeg", 1),
        );
        const finalFileName = compressedFile.name || "compressed_image.jpeg";
        const finalCompressedFile = new File([blob], finalFileName, {
          type: "image/jpeg",
          lastModified: Date.now(),
        });

        console.log(
          "Compressed & resized size:",
          (finalCompressedFile.size / 1024 / 1024).toFixed(2),
          "MB",
        );

        if (finalCompressedFile.size > maxSizeMB * 1024 * 1024) {
          alert(
            "Image is still larger than 2MB after compression. Please choose a smaller image.",
          );
          return;
        }

        const reader = new FileReader();
        reader.onloadend = () => setPreview(reader.result);
        reader.readAsDataURL(finalCompressedFile);

        setSelectedImage(finalCompressedFile);
      } else {
        // If no resizing needed
        const reader = new FileReader();
        reader.onloadend = () => setPreview(reader.result);
        reader.readAsDataURL(compressedFile);

        setSelectedImage(compressedFile);
      }
    } catch (error) {
      console.error("Compression Error:", error);
      alert("Image compression failed!");
    }
  };

  const compressImage = (file, targetSize = 0.9 * 1024 * 1024) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;

        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          let width = img.width;
          let height = img.height;

          const scaleFactor = Math.sqrt(targetSize / file.size);

          canvas.width = width * scaleFactor;
          canvas.height = height * scaleFactor;

          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          canvas.toBlob(
            (blob) => {
              const fileName = file.name
                ? file.name.replace(/\.[^/.]+$/, "")
                : "compressed_image";
              const finalFileName = `${fileName}.jpeg`;

              const compressedFile = new File([blob], finalFileName, {
                type: "image/jpeg",
                lastModified: Date.now(),
              });

              console.log(
                "Compressed File Size:",
                (compressedFile.size / 1024 / 1024).toFixed(2),
                "MB",
              );
              resolve(compressedFile);
            },
            "image/jpeg",
            1, // quality
          );
        };
      };
    });
  };

  useEffect(() => {
    if (studentId) {
      getStudent(studentId);
    }
  }, [studentId]);
  const getStudent = async (id) => {
    setLoading(true);
    try {
      const response = await studentDetails(`id=${id}`);
      if (response.data.status) {
        setStudentView(response?.data.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };
  const getState = async () => {
    setLoading(true);
    try {
      const response = await StateFetch();
      if (response.data) {
        setStates(response.data.states);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const getDistrict = async (state = "") => {
    setLoading(true);
    try {
      const response = await DistrictFetch(state);
      if (response.data) {
        setDistricts(response.data.districts);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const UpdateStudent = async (e) => {
    setLoading(true);
    e.preventDefault();
    try {
      const formData = new FormData(e.target);

      if (selectedImage) {
        formData.append("image", selectedImage);
        console.log(
          "Original size:",
          (originalFile.size / 1024 / 1024).toFixed(2),
          "MB",
        );
        console.log(
          "Compressed size:",
          (selectedImage.size / 1024 / 1024).toFixed(2),
          "MB",
        );
      }

      const response = await studentUpdate(formData);
      if (response?.data?.status) {
        setError("");
        e.target.reset();
        SweetAlertShow(
          "success",
          "successfully",
          response?.data?.message ?? response?.data?.data?.message,
        );
        navigate(-1);
      } else {
        if (response?.data?.errors) {
          setError(response?.data?.errors);
        }
        SweetAlertShow(
          "info",
          "Warning",
          response?.data?.message ?? response?.data?.data?.message,
        );
      }
    } catch (error) {
      if (error?.response?.data?.errors) {
        setError(error?.response?.data?.errors);
      }

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.message ??
        error?.data?.data?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getState();
    getDistrict();
  }, []);

  const [educationList, setEducationList] = useState([
    {
      course_name: "",
      school_name: "",
      year: "",
      score: "",
    },
  ]);
  const addRow = () => {
    setEducationList([
      ...educationList,
      { course_name: "", school_name: "", year: "", score: "" },
    ]);
  };

  const handleEducationChange = (value, field, index) => {
    const list = [...educationList];
    list[index][field] = value;
    setEducationList(list);
  };

  useEffect(() => {
    setEducationList(
      JSON.parse(studentView?.student?.education_details ?? "[]") ?? [
        {
          course_name: "",
          school_name: "",
          year: "",
          score: "",
        },
      ],
    );
  }, [studentView?.student]);

  const removeRow = (index) => {
    const list = [...educationList];
    list.splice(index, 1);
    setEducationList(list);
  };
  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <Master />
                  <div className="col-12">
                    <div className="card p-4 py-4">
                      <div className="d-flex justify-content-between">
                        {" "}
                        <h4 className="mb-4 text-primary fw-bold">
                          Student Update
                        </h4>
                        <Link
                          to={"/students"}
                          className="btn btn-outline-primary mb-4"
                        >
                          <i className="bi bi-arrow-left-circle me-1"></i> Back
                        </Link>
                      </div>
                      <form onSubmit={UpdateStudent}>
                        <div className="col-md-12">
                          <p className="text-primary fs-5 mb-0">
                            Basic Details
                          </p>
                          <hr />
                        </div>
                        <div className="row g-3">
                          <input
                            type="hidden"
                            name="id"
                            value={studentId}
                            required
                          />
                          <div className="col-md-4 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                            <input
                              type="text"
                              className="form-control"
                              name="registration"
                              placeholder="Registration_no"
                              onChange={(e) => setSearchReg(e.target.value)}
                              defaultValue={studentView?.registration_no}
                            />
                            <label className="ms-5">
                              Registration No{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <span className="text-danger fs-10">
                              {alredy?.message || ""}
                            </span>
                            <span className="text-danger">
                              {" "}
                              {error?.registration ?? ""}
                            </span>
                          </div>
                          <div className="col-md-4 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                            <input
                              type="text"
                              className="form-control input-uppercase"
                              placeholder="Student Name"
                              name="name"
                              defaultValue={studentView?.name}
                              onChange={(e) => {
                                let val = e.target.value.toUpperCase();
                                e.target.value = val;
                              }}
                              required
                            />
                            <label className="ms-5">
                              Student Name{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <span className="text-danger">
                              {" "}
                              {error?.name ?? ""}
                            </span>
                          </div>
                          <div className="col-md-4 form-floating form-floating-outline mb-2 fv-plugins-icon-container mt-2">
                            <input
                              type="tel"
                              className="form-control"
                              placeholder="Mobile Number"
                              name="mobile"
                              defaultValue={studentView?.phone}
                              required
                              maxLength={10}
                              minLength={10}
                            />
                            <label className="ms-5">
                              Mobile No <span className="text-danger">*</span>
                            </label>
                            <span className="text-danger">
                              {" "}
                              {error?.mobile ?? ""}
                            </span>
                          </div>
                          {getField("father_name").show === 1 && (
                            <div className="col-md-4 form-floating form-floating-outline mb-2 fv-plugins-icon-container mt-2">
                              <input
                                type="text"
                                className="form-control input-uppercase"
                                placeholder="Father Name"
                                name="father_name"
                                defaultValue={studentView?.father_name}
                                required
                                onChange={(e) => {
                                  let val = e.target.value.toUpperCase();
                                  e.target.value = val;
                                }}
                              />
                              <label className="ms-5">
                                Father's Name{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <span className="text-danger">
                                {" "}
                                {error?.father_name ?? ""}
                              </span>
                            </div>
                          )}
                          {getField("mother_name").show === 1 && (
                            <div className="col-md-4 form-floating form-floating-outline mb-2 fv-plugins-icon-container mt-2">
                              <input
                                type="text"
                                className="form-control input-uppercase"
                                placeholder="Mother Name"
                                name="mother_name"
                                defaultValue={studentView?.mother_name}
                                onChange={(e) => {
                                  let val = e.target.value.toUpperCase();
                                  e.target.value = val;
                                }}
                              />
                              <label className="ms-5">Mother's Name </label>
                              <span className="text-danger">
                                {" "}
                                {error?.mother_name ?? ""}
                              </span>
                            </div>
                          )}

                          {getField("father_mobile").show === 1 && (
                            <div className="col-md-4 form-floating form-floating-outline mb-2 fv-plugins-icon-container mt-2">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Father Mobile"
                                name="father_mobile"
                                defaultValue={studentView?.father_mobile}
                              />
                              <label className="ms-5">Father Mobile</label>
                              <span className="text-danger">
                                {error?.father_mobile ?? ""}
                              </span>
                            </div>
                          )}
                          {getField("father_aadhar").show === 1 && (
                            <div className="col-md-4 form-floating form-floating-outline mb-2 fv-plugins-icon-container mt-2">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Father Aadhar"
                                name="father_aadhar"
                                defaultValue={studentView?.father_aadhar}
                              />
                              <label className="ms-5">Father Aadhar</label>
                              <span className="text-danger">
                                {error?.father_aadhar ?? ""}
                              </span>
                            </div>
                          )}

                          {getField("mother_mobile").show === 1 && (
                            <div className="col-md-4 form-floating form-floating-outline mb-2 fv-plugins-icon-container mt-2">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Mother Mobile"
                                name="mother_mobile"
                                defaultValue={studentView?.mother_mobile}
                              />
                              <label className="ms-5">Mother Mobile</label>
                              <span className="text-danger">
                                {error?.mother_mobile ?? ""}
                              </span>
                            </div>
                          )}

                          {getField("mother_aadhar").show === 1 && (
                            <div className="col-md-4 form-floating form-floating-outline mb-2 fv-plugins-icon-container mt-2">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Mother Aadhar"
                                name="mother_aadhar"
                                defaultValue={studentView?.mother_aadhar}
                              />
                              <label className="ms-5">Mother Aadhar</label>
                              <span className="text-danger">
                                {error?.mother_aadhar ?? ""}
                              </span>
                            </div>
                          )}

                          {getField("caste_name").show === 1 && (
                            <div className="col-md-4 form-floating form-floating-outline mb-2 fv-plugins-icon-container mt-2">
                              <input
                                type="text"
                                className="form-control input-uppercase"
                                placeholder="Caste Name"
                                name="caste_name"
                                defaultValue={studentView?.caste_name}
                                onChange={(e) => {
                                  e.target.value = e.target.value.toUpperCase();
                                }}
                              />
                              <label className="ms-5">Caste Name</label>
                              <span className="text-danger">
                                {error?.caste_name ?? ""}
                              </span>
                            </div>
                          )}

                          {getField("religion").show === 1 && (
                            <div className="col-md-4 form-floating form-floating-outline mb-2 fv-plugins-icon-container mt-2">
                              <select
                                className="form-control form-select"
                                name="religion"
                                value={studentView?.religion || ""}
                                onChange={(e) =>
                                  setStudentView((prev) => ({
                                    ...prev,
                                    religion: e.target.value,
                                  }))
                                }
                              >
                                <option value="">Select Religion</option>
                                <option value="HINDU">HINDU</option>
                                <option value="MUSLIM">MUSLIM</option>
                                <option value="SIKH">SIKH</option>
                                <option value="CHRISTIAN">CHRISTIAN</option>
                                <option value="JAIN">JAIN</option>
                                <option value="BUDDHIST">BUDDHIST</option>
                                <option value="OTHER">OTHER</option>
                              </select>
                              <label className="ms-5">Religion</label>
                              <span className="text-danger">
                                {error?.religion ?? ""}
                              </span>
                            </div>
                          )}
                          {getField("pen_no").show === 1 && (
                            <div className="col-md-4 form-floating form-floating-outline mb-2 fv-plugins-icon-container mt-2">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="PAN No"
                                name="pen_no"
                                defaultValue={studentView?.pen_no}
                              />
                              <label className="ms-5">PAN No</label>
                              <span className="text-danger">
                                {error?.pen_no ?? ""}
                              </span>
                            </div>
                          )}

                          {getField("jan_aadhar").show === 1 && (
                            <div className="col-md-4 form-floating form-floating-outline mb-2 fv-plugins-icon-container mt-2">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Jan Aadhar"
                                name="jan_aadhar"
                                defaultValue={studentView?.jan_aadhar}
                              />
                              <label className="ms-5">Jan Aadhar</label>
                              <span className="text-danger">
                                {error?.jan_aadhar ?? ""}
                              </span>
                            </div>
                          )}

                          {getField("admission_class").show === 1 && (
                            <div className="col-md-4 form-floating form-floating-outline mb-2 fv-plugins-icon-container mt-2">
                              <input
                                type="text"
                                className="form-control input-uppercase"
                                placeholder="Admission Class"
                                name="admission_class"
                                defaultValue={studentView?.admission_class}
                                onChange={(e) => {
                                  e.target.value = e.target.value.toUpperCase();
                                }}
                              />
                              <label className="ms-5">Admission Class</label>
                              <span className="text-danger">
                                {error?.admission_class ?? ""}
                              </span>
                            </div>
                          )}
                          <div className="col-md-4 form-floating form-floating-outline mb-2 fv-plugins-icon-container mt-2">
                            <select
                              className="form-control form-select"
                              name="gender"
                              required
                              value={studentView?.gender || ""}
                              onChange={(e) =>
                                setStudentView((prev) => ({
                                  ...prev,
                                  gender: e.target.value,
                                }))
                              }
                            >
                              <option value="">Select Gender</option>
                              <option value="Male">Male</option>
                              <option value="Female">Female</option>
                              <option value="Other">Other</option>
                            </select>

                            <label className="ms-5">
                              Gender <span className="text-danger">*</span>
                            </label>
                            <span className="text-danger">
                              {" "}
                              {error?.gender ?? ""}
                            </span>
                          </div>
                          <div className="col-md-4 form-floating form-floating-outline mb-2 fv-plugins-icon-container mt-2">
                            <input
                              type="tel"
                              className="form-control"
                              placeholder="Alternative mobile no"
                              name="secondary_mobile"
                              value={studentView?.secondary_mobile || ""}
                              onChange={(e) =>
                                setStudentView((prev) => ({
                                  ...prev,
                                  secondary_mobile: e.target.value,
                                }))
                              }
                              minLength={10}
                              maxLength={10}
                            />

                            <label className="ms-5">Alternative mobile no</label>

                            <span className="text-danger">
                              {error?.secondary_mobile ?? ""}
                            </span>
                          </div>
                          <div className="col-md-4 form-floating form-floating-outline mb-2 fv-plugins-icon-container mt-2">
                            <input
                              type="email"
                              className="form-control"
                              placeholder="Email"
                              name="email"
                              defaultValue={studentView?.email}
                            />
                            <label className="ms-5">Email </label>
                            <span className="text-danger">
                              {" "}
                              {error?.email ?? ""}
                            </span>
                          </div>

                          <div className="col-md-4 form-floating form-floating-outline mb-2 fv-plugins-icon-container mt-2">
                            <select
                              name="category"
                              className="form-control form-select"
                              value={studentView?.category || ""}
                              onChange={(e) =>
                                setStudentView((prev) => ({
                                  ...prev,
                                  category: e.target.value,
                                }))
                              }
                            >
                              <option value="">Select Category</option>
                              <option value="GEN">GEN</option>
                              <option value="EWS">EWS</option>
                              <option value="OBC">OBC</option>
                              <option value="SC">SC</option>
                              <option value="ST">ST</option>
                              <option value="MBC">MBC</option>
                            </select>
                            <label className="ms-5">Category</label>
                            <span className="text-danger">
                              {" "}
                              {error?.category ?? ""}
                            </span>
                          </div>
                          <div className="col-lg-4 col-sm-6 form-floating form-floating-outline">
                            <select
                              name="hostel_status"
                              className="form-control form-select"
                              value={studentView?.hostel_status || ""}
                              onChange={(e) =>
                                setStudentView((prev) => ({
                                  ...prev,
                                  hostel_status: e.target.value,
                                }))
                              }
                            >
                              <option value="">Select Hostel Status</option>
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                            </select>
                            <label>Hostel Status</label>
                          </div>
                          <div className="col-lg-4 col-sm-6 form-floating form-floating-outline">
                            <select
                              name="medium"
                              className="form-control form-select"
                              value={studentView?.medium || ""}
                              onChange={(e) =>
                                setStudentView((prev) => ({
                                  ...prev,
                                  medium: e.target.value,
                                }))
                              }
                            >
                              <option value="">Select Medium</option>
                              <option value="Hindi">Hindi</option>
                              <option value="English">English</option>
                            </select>
                            <label>Medium</label>
                          </div>

                          <div className="col-lg-4 col-sm-6 form-floating form-floating-outline">
                            <input
                              type="text"
                              className="form-control"
                              name="father_occupation"
                              placeholder="Father Occupation"
                              defaultValue={studentView?.father_occupation}
                            />
                            <label>Father Occupation</label>
                          </div>
                          <div className="col-lg-4 col-sm-6 form-floating form-floating-outline">
                            <input
                              type="date"
                              className="form-control"
                              name="admission_date"
                              defaultValue={studentView?.admission_date}
                            />
                            <label>Admission Date</label>
                          </div>

                          <div className="col-lg-4 col-sm-6 form-floating form-floating-outline">
                            <input
                              type="text"
                              className="form-control"
                              name="aadhar"
                              placeholder="Aadhar no. "
                              maxLength={12}
                              minLength={12}
                              defaultValue={studentView?.aadhar}
                            />
                            <label>Aadhar No</label>
                            <span className="text-danger">
                              {" "}
                              {error?.aadhar ?? ""}{" "}
                            </span>
                          </div>

                          <div className="col-lg-4 col-sm-6 form-floating form-floating-outline">
                            <input
                              type="Date"
                              className="form-control"
                              name="dob"
                              placeholder="Date of Birth "
                              defaultValue={studentView?.dob}
                            />
                            <label>DOB</label>
                            <span className="text-danger">
                              {" "}
                              {error?.dob ?? ""}{" "}
                            </span>
                          </div>

                          <div className="col-lg-4 col-sm-6 form-floating form-floating-outline">
                            <input
                              type="text"
                              className="form-control"
                              name="nic_id"
                              placeholder="NIC ID "
                              defaultValue={studentView?.nic_id}
                            />
                            <label>NIC ID</label>
                            <span className="text-danger">
                              {" "}
                              {error?.nic_id ?? ""}{" "}
                            </span>
                          </div>

                          <div className="col-lg-4 col-sm-6 form-floating form-floating-outline">
                            <input
                              type="text"
                              className="form-control"
                              name="apaar_id"
                              placeholder="Apaar ID "
                              defaultValue={studentView?.apaar_id}
                            />
                            <label>Apaar ID</label>
                            <span className="text-danger">
                              {" "}
                              {error?.apaar_id ?? ""}{" "}
                            </span>
                          </div>

                          <div className="col-lg-4 col-sm-6 form-floating form-floating-outline">
                            <select
                              name="student_type"
                              className="form-control form-select"
                              value={studentView?.student_type || ""}
                              onChange={(e) =>
                                setStudentView((prev) => ({
                                  ...prev,
                                  student_type: e.target.value,
                                }))
                              }
                            >
                              <option value="">Select Student Type</option>
                              <option value="student">Student</option>
                              <option value="working_professional">
                                Working Professional
                              </option>
                            </select>
                            <label>Student Type</label>
                          </div>
                        </div>
                        <div className="mt-3">
                          <p className="text-primary fs-5 mb-0">
                            Education Details
                          </p>
                          <hr />
                        </div>

                        {educationList.map((item, i) => (
                          <div key={i} className="row mb-5">
                            <div className="col-lg-3 col-sm-6 form-floating form-floating-outline">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Last Education"
                                name={`education_details[${i}][course_name]`}
                                value={item?.course_name}
                                onChange={(e) =>
                                  handleEducationChange(
                                    e.target.value,
                                    "course_name",
                                    i,
                                  )
                                }
                              />
                              <label>Last Education</label>
                            </div>

                            <div className="col-lg-3 col-sm-6 form-floating form-floating-outline">
                              <input
                                type="text"
                                className="form-control input-uppercase"
                                placeholder="School Name"
                                name={`education_details[${i}][school_name]`}
                                value={item.school_name}
                                onChange={(e) =>
                                  handleEducationChange(
                                    e.target.value,
                                    "school_name",
                                    i,
                                  )
                                }
                              />
                              <label>School Name</label>
                            </div>
                            <div className="col-lg-2 col-sm-6 form-floating form-floating-outline">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Year"
                                name={`education_details[${i}][year]`}
                                value={item.year}
                                onChange={(e) =>
                                  handleEducationChange(
                                    e.target.value,
                                    "year",
                                    i,
                                  )
                                }
                              />
                              <label>Year</label>
                            </div>

                            <div className="col-lg-2 col-sm-6 form-floating form-floating-outline">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Score"
                                name={`education_details[${i}][score]`}
                                value={item.score}
                                onChange={(e) =>
                                  handleEducationChange(
                                    e.target.value,
                                    "score",
                                    i,
                                  )
                                }
                              />
                              <label>Score</label>
                            </div>

                            <div className="col-lg-2 d-flex align-items-center gap-2">
                              {educationList.length !== 1 && (
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm"
                                  onClick={() => removeRow(i)}
                                >
                                  -
                                </button>
                              )}

                              {i === 0 && (
                                <button
                                  type="button"
                                  className="btn btn-success btn-sm"
                                  onClick={addRow}
                                >
                                  +
                                </button>
                              )}
                            </div>
                          </div>
                        ))}

                        <div className="col-md-12">
                          <p className="text-primary fs-5 mb-0">
                            Address Details
                          </p>
                          <hr />
                        </div>
                        <div className="row">
                          <div className="col-md-4 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                            <input
                              type="text"
                              className="form-control input-uppercase"
                              name="village"
                              defaultValue={studentView?.village}
                            />
                            <label className="ms-5">
                              Village <span className="text-danger">*</span>
                            </label>
                            <span className="text-danger">
                              {" "}
                              {error?.village ?? ""}
                            </span>
                          </div>
                          <div className="col-md-4 mb-5 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                            <select
                              className="form-select form-control"
                              name="state"
                              value={studentView?.state || ""}
                              onChange={(e) => {
                                const value = e.target.value;
                                setStudentView((prev) => ({
                                  ...prev,
                                  state: value,
                                  district: "",
                                }));

                                getDistrict(value);
                              }}
                            >
                              <option value="">Select State</option>
                              {states.map((state) => (
                                <option key={state.id} value={state.name}>
                                  {state.name}
                                </option>
                              ))}
                            </select>
                            <label className="ms-5">
                              State <span className="text-danger">*</span>
                            </label>
                            <span className="text-danger">
                              {" "}
                              {error?.state ?? ""}
                            </span>
                          </div>
                          <div className="col-md-4 mb-5 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                            <select
                              className="form-select"
                              name="district"
                              value={studentView?.district || ""}
                              onChange={(e) =>
                                setStudentView((prev) => ({
                                  ...prev,
                                  district: e.target.value,
                                }))
                              }
                            >
                              <option value="">Select District</option>

                              {districts.map((district) => (
                                <option key={district.id} value={district.name}>
                                  {district.name}
                                </option>
                              ))}
                            </select>
                            <label className="ms-5">
                              District <span className="text-danger">*</span>
                            </label>
                            <span className="text-danger">
                              {" "}
                              {error?.district ?? ""}
                            </span>
                          </div>
                          <div className="col-md-4 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Pincode"
                              name="pincode"
                              defaultValue={studentView?.zipcode}
                            />
                            <label className="ms-5">
                              Pincode <span className="text-danger">*</span>
                            </label>
                            <span className="text-danger">
                              {" "}
                              {error?.pincode ?? ""}
                            </span>
                          </div>

                          <div className="col-lg-4 col-sm-3">
                            <label className="btn btn-outline-primary d-flex align-items-center me-2">
                              <input
                                hidden
                                type="file"
                                id="imageInput"
                                name="image"
                                accept="image/png, image/jpeg"
                                onChange={handleImageChange_2}
                                capture="environment"
                              />
                              <i className="ri-upload-2-line me-1"></i> Upload
                              Profile
                            </label>

                            {/* <label className="btn btn-outline-success d-flex align-items-center">
                                <input
                                  hidden
                                  type="file"
                                  id="cameraInput"
                                  name="camera"
                                  accept="image/*"
                                  capture="environment"  
                                  onChange={handleImageChange_2}
                                />
                                <i className="ri-camera-line me-1"></i> Capture Photo
                              </label> */}

                            <small className="text-danger d-block">
                              Image size must be less than 2MB
                            </small>
                            <span className="text-danger">
                              {error?.image ?? ""}
                            </span>

                            {(preview || studentView?.profile_picture) && (
                              <div
                                className="position-relative mt-3"
                                style={{ width: "120px", height: "120px" }}
                              >
                                <img
                                  src={
                                    preview
                                      ? preview
                                      : `${imgBaseUrl}${studentView.profile_picture}`
                                  }
                                  alt="Student"
                                  className="rounded-circle border shadow-sm img-fluid"
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                  }}
                                  onError={(e) => {
                                    e.target.src = "/assets/img/avatars/1.png"; // fallback image
                                  }}
                                />

                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger position-absolute top-0 end-0 translate-middle"
                                  style={{
                                    width: 24,
                                    height: 24,
                                    borderRadius: "50%",
                                    padding: 0,
                                  }}
                                  onClick={() => {
                                    setPreview(null);
                                    setSelectedImage(null);

                                    const imageInput =
                                      document.getElementById("imageInput");
                                    if (imageInput) imageInput.value = "";

                                    // Optional:
                                    // setStudentView(prev => ({
                                    //   ...prev,
                                    //   profile_picture: null,
                                    // }));
                                  }}
                                >
                                  ×
                                </button>
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="d-flex justify-content-end gap-2">
                          <button
                            type="submit"
                            className="btn btn-primary px-5"
                            disabled={loading} // Disable the button while loading
                          >
                            {loading ? (
                              <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                            ) : (
                              "Submit"
                            )}
                            {loading ? " Submitting..." : ""}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
